module.exports = __webpack_public_path__ + "static/media/ian_judge_headshot.79bb5c09.jpeg";